import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 md:py-32 bg-offwhite px-6 md:px-12" data-id="element-8">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16 md:gap-24" data-id="element-9">
        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full md:w-1/2" data-id="element-10">
          <div className="aspect-[3/4] relative" data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/wKKVRj4S4hdQkGpbTbpCSh/image.png" alt="Alejandro Noriega" className="w-full h-full object-cover" data-id="element-12" />
          </div>
        </motion.div>

        {/* Text */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full md:w-1/2" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-8" data-id="element-14">
            The Artist
          </h2>
          <div className="space-y-6 text-gray-600 font-sans leading-relaxed text-sm md:text-base mb-10" data-id="element-15">
            <p data-id="element-16">
              Alejandro Noriega is a street and fine art photographer based
              between Argentina and Spain. His work is grounded in a sustained
              inquiry into human presence, shaped by over fifteen years of
              photographic practice.
            </p>
            <p data-id="element-17">
              His series{' '}
              <em className="text-charcoal font-medium" data-id="element-18">
                Entre Luces y Sombras
              </em>
              , developed across six countries, uses high-contrast black and
              white imagery to construct a visual language around inner
              transformation. The work is not observational but reflective,
              engaging with fear, identity, and the process of self-recognition.
            </p>
            <p data-id="element-19">
              At its core, the series seeks to bring awareness to the importance
              of knowing oneself, confronting what lies in the shadows, and
              moving through it. To inhabit one's own being, fully and
              consciously.
            </p>
          </div>

          <a href="https://www.instagram.com/alenoriegaes" target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-3 text-charcoal hover:opacity-60 transition-opacity" data-id="element-20">
            <Instagram size={20} data-id="element-21" />
            <span className="text-xs font-medium tracking-[0.2em] uppercase" data-id="element-22">
              Follow @alenoriegaes
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}